import { render, staticRenderFns } from "./shared_trip.vue?vue&type=template&id=307842d3&scoped=true"
import script from "./shared_trip.vue?vue&type=script&lang=js"
export * from "./shared_trip.vue?vue&type=script&lang=js"
import style0 from "./shared_trip.vue?vue&type=style&index=0&id=307842d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307842d3",
  null
  
)

export default component.exports